import { render, staticRenderFns } from "./ExchangeDifference.vue?vue&type=template&id=3de65f75"
import script from "./ExchangeDifference.vue?vue&type=script&lang=js"
export * from "./ExchangeDifference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports